import React from "react";
import { Link } from "react-router-dom";
import { Image } from "../../AbstractElements";
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "../../redux-toolkit/store";
import { setSideBarToggle } from "../../redux-toolkit/reducers/LayoutReducer";
import SvgIcon from "../../Utils/CommonComponents/CommonIcons/CommonSvgIcons";
import { dynamicImage } from "../../Utils";

export default function LogoWrapper() {
    const dispatch = useDispatch();
    const layoutState = useSelector((state: RootState) => state.layout);
    const handleSidebarToggle = () => {
        dispatch(setSideBarToggle(!layoutState.sideBarToggle));
      };

    return (
        <div className='logo-wrapper bg-white py-2' >
            <Link to={`/admin`}>
                <Image className='img-fluid' src={dynamicImage(`logo/logo.png`)} alt='logo' style={{ width: '110px' , paddingLeft: '10px' }} />
            </Link>
            <div className='toggle-sidebar' onClick={handleSidebarToggle} >
                <SvgIcon className='sidebar-toggle' style={{ cursor: 'pointer', color: '#1B202F', }} iconId='toggle-icon' />
            </div>
        </div>
    )
}